import { useState, useEffect } from 'react';
import Layout from './components/Layout';
import BusinessOverview from './pages/BusinessOverview';
import MarketTrends from './pages/MarketTrends';
import NAMSales from './pages/NAMSales';
import Forecast from './pages/Forecast';
import Distribution from './pages/Distribution';
import StorePerformance from './pages/StorePerformance';
import StoreMaster from './pages/StoreMaster';
import RangingMatrix from './pages/RangingMatrix';
import Promotions from './pages/Promotions';
import PromotionsV2 from './pages/PromotionsV2';
import PromoEffectiveness from './pages/PromoEffectiveness';
import Recommendations from './pages/Recommendations';
import KeyDates from './pages/KeyDates';
import Commercials from './pages/Commercials';
import Pricing from './pages/Pricing';
import CostMix from './pages/CostMix';
import ProductDetails from './pages/ProductDetails';
import ScanItems from './pages/ScanItems';
import { RebateMaster, TransportAllocation, RrpItems, PromoRrp, CustomerDC, GrowthGrid } from './pages/CommercialMaster';
import AllocationReview from './pages/AllocationReview';
import MasterDataAI from './pages/MasterDataAI';
import DataSources from './pages/DataSources';
import Merchandising from './pages/Merchandising';
import SpacePlanning from './pages/SpacePlanning';
import CRM from './pages/CRM';
import NewBusiness from './pages/NewBusiness';
import ExportCustomers from './pages/ExportCustomers';
import RetailerProfiles from './pages/RetailerProfiles';
import ChannelStrategy from './pages/ChannelStrategy';
import CapacityReview from './pages/CapacityReview';
import AIProjects from './pages/AIProjects';
import DR from './pages/DR';
import Governance from './pages/Governance';

const PAGES = {
  overview: BusinessOverview,
  trends: MarketTrends,
  nam: NAMSales,
  forecast: Forecast,
  distribution: Distribution,
  stores: StorePerformance,
  'store-master': StoreMaster,
  'ranging-matrix': RangingMatrix,
  'promotions-legacy': Promotions,
  'promo-roi': PromoEffectiveness,
  'recommendations': Recommendations,
  'key-dates': KeyDates,
  commercials: Commercials,
  pricing: Pricing,
  'cost-mix': CostMix,
  'product-details': ProductDetails,
  'scan-items': ScanItems,
  'rebate-master': RebateMaster,
  'growth-grid': GrowthGrid,
  'transport-allocation': TransportAllocation,
  'allocation-review': AllocationReview,
  'rrp-items': RrpItems,
  'promo-rrp': PromoRrp,
  'customer-dcs': CustomerDC,
  'master-data-ai': MasterDataAI,
  merchandising: Merchandising,
  'space-planning': SpacePlanning,
  crm: CRM,
  'new-business': NewBusiness,
  'export-customers': ExportCustomers,
  'retailer-profiles': RetailerProfiles,
  'channel-strategy': ChannelStrategy,
  'capacity-review': CapacityReview,
  'ai-projects': AIProjects,
  dr: DR,
  governance: Governance,
  'data-sources': DataSources,
};

// Trade & Marketing: three sidebar entries, one shared canvas. Each id opens
// PromotionsV2 on a different view (sales grid / marketing Gantt / consolidated
// calendar) — the component reads `view` directly so switching is instant (no
// remount, FY selection persists).
const PROMO_VIEW = {
  promotions: 'sales',
  'marketing-calendar': 'marketing',
  'activity-calendar': 'plan',
};

export default function App() {
  const [tab, setTab] = useState('overview');
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'light');

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  const promoView = PROMO_VIEW[tab];
  const Page = PAGES[tab];
  return (
    <Layout activeTab={tab} onTabChange={setTab} theme={theme} onToggleTheme={toggleTheme}>
      {promoView ? <PromotionsV2 view={promoView} /> : <Page />}
    </Layout>
  );
}
